import React from "react";
import { connect } from "react-redux";
import WelcomeComponent from "../Components/WelcomeComponent";
import {
  selectConductQuestion,
  setConductNode,
  setLanguages
} from "../Actions/ConductAction";
import ButtonContainer from "./ButtonContainer";
import LanguageComponent from "../Components/LanguageComponent";

const WelcomeContainer = props => {
  const { conduct, setLanguages } = props;

  return (
    <div className={"page"} id="welcome_page">
      <LanguageComponent
        conduct={conduct}
        setLanguages={setLanguages}
      />
      <WelcomeComponent conduct={conduct} setLanguages={setLanguages} />
      <ButtonContainer />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    conduct: state.conductReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setQuestions: id => {
      dispatch(selectConductQuestion(id));
    },
    setConductNode: page => {
      dispatch(setConductNode(page));
    },
    setLanguages: (path, key, surveyID, languageID, isPublish) => {
      path = `survey/language/${languageID}`;
      dispatch(
        setLanguages(path + `?key=${key}&type=publish&lang=${languageID}`)
      );
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeContainer);
